export const sessionError = (err) => {
  const error = err.response?.data?.message
  const msg2 = "Iniciaste sesión en otro lugar, vuelve a iniciar sesión para continuar."
  const msg = "Ya iniciaste sesión en otro dispositivo, vuelve a iniciar sesión para continuar."
  return error === msg || error === msg2
}
